import React, { useState, useEffect } from 'react';
import './ImageCarousel2.css';

const ImageCarousel2 = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  // Array of image paths from the public directory
  const images = [
    '/Images/Carousel/2/17.png',
    '/Images/Carousel/2/18.png',
    '/Images/Carousel/2/19.png',
    '/Images/Carousel/2/20.png',
    '/Images/Carousel/2/21.png',
    '/Images/Carousel/2/22.png'
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % images.length
      );
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(intervalId);
  }, [images.length]);

  return (
    <div className="image-carousel-2">
      <div className="carousel-container-2">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Carousel 2 ${index + 1}`}
            className={`carousel-image-2 ${index === currentImageIndex ? 'active' : ''}`}
            loading="lazy"
          />
        ))}
      </div>
      <div className="carousel-indicators-2">
        {images.map((_, index) => (
          <button
            key={index}
            className={`indicator-2 ${index === currentImageIndex ? 'active' : ''}`}
            onClick={() => setCurrentImageIndex(index)}
            aria-label={`Go to image ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel2;
